import { Card, CardBody, CardHeader, Input } from 'reactstrap';
import { AssistantExamResponse, ExamFile } from '../../../types/Exams';
import AjaxSourcedData from '../../formsAndTable/tables/dataTables/dataSource/AjaxSourcedData';
import { useTranslation } from 'react-i18next';
import { getCrmExaminationsTableColumns } from '../../../data/formsAndTable/tables/dataTables/DataSource';
import { useLeadGetExaminationsQuery } from '../../../reduxToolkit/reducers/usersSlice';
import { useEffect, useState } from 'react';
import { baseLang } from '../../../lib/utils';
import { PreviewItem } from '../../commetFileModal';
import CommonCardHeader from '../../../coreComponents/CommonCardHeader';
import Loader from '../../../layout/Loader';
import Error404 from '../../pages/others/errorPage/Error404';
import { isNewPreview } from '../../../utils';
import { NoDataComponent } from '../../formsAndTable/forms/formControls/NoDataComponent';

type Props = {
  handleModalOpen: (
    exam_id: number,
    examComment: string,
    detailsId: number | null,
    files: ExamFile[] | null | undefined,
  ) => void;
  setTabsTotals: React.Dispatch<
    React.SetStateAction<{ unset: number; future: number; past: number }>
  >;
};

const FutureExaminations = ({ handleModalOpen, setTabsTotals }: Props) => {
  const { t, i18n } = useTranslation();
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(50);
  const [sort, setSort] = useState<'asc' | 'desc'>('asc');
  const [sortKey, setSortKey] = useState('examDate');
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [previews, setPreviews] = useState<PreviewItem[]>([]);
  const pageLang = baseLang(i18n.language);

  useEffect(() => {
    const id = setTimeout(() => setDebouncedSearch(search.trim()), 400);
    return () => clearTimeout(id);
  }, [search]);
  const viewerTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const {
    data: futureData,
    isLoading,
    isFetching,
    isError,
  } = useLeadGetExaminationsQuery({
    scope: 'future',
    page,
    perPage,
    sort,
    sortKey,
    search: debouncedSearch,
  });

  useEffect(() => {
    if (futureData) {
      setTotalRows(futureData.total);
      setTabsTotals((prev) => ({ ...prev, future: futureData.total }));
    }
  }, [futureData]);

  // Revoke object URLs on unmount
  useEffect(() => {
    return () => {
      previews.forEach((p) => {
        if (isNewPreview(p)) URL.revokeObjectURL(p.url);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let cancelled = false;
    previews.forEach((p) => {
      if (p.w && p.h) return;
      const img = new Image();
      img.onload = () => {
        if (cancelled) return;
        setPreviews((prev) => {
          const copy = [...prev];
          const ix = copy.findIndex((x) => x.url === p.url);
          if (ix !== -1) {
            copy[ix] = { ...copy[ix], w: img.naturalWidth || 1600, h: img.naturalHeight || 1200 };
          }
          return copy;
        });
      };
      img.src = p.url;
    });
    return () => {
      cancelled = true;
    };
  }, [previews]);

  const initialLoading = isLoading && !futureData;
  if (isError) return <Error404 />;
  return (
    <>
      <CardBody>
        {initialLoading ? (
          <Loader />
        ) : (
          futureData && (
            <AjaxSourcedData
              //  key={"future"}
              data={futureData.items}
              columns={getCrmExaminationsTableColumns(
                t,
                viewerTz,
                'future',
                pageLang,
                handleModalOpen,
              )}
              pagination={true}
              paginationServer={true}
              paginationPerPage={perPage}
              paginationDefaultPage={1}
              paginationTotalRows={totalRows}
              onChangePage={(p) => setPage(p)}
              onChangeRowsPerPage={(newPerPage, p) => {
                setPerPage(newPerPage);
                setPage(1); // or p, depending on your UX
              }}
              /* (optional) server sorting */
              sortServer
              onSort={(column, direction) => {
                // column.selector or column.sortField depending on your column defs
                console.log('Sorting', column, direction);
                const key = (column as any).sortField ?? (column as any).selector;
                console.log('Sorting', key, direction);
                setSort(direction);
                setSortKey(key);
              }}
              defaultSortAsc={false}
              searchServer
              searchText={search}
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
              // conditionalRowStyles={conditionalRowStyles}
              paginationRowsPerPageOptions={[10, 25, 50]}
              noDataComponent={<NoDataComponent />}
            />
          )
        )}
      </CardBody>
      {/* </Card> */}
    </>
  );
};
export default FutureExaminations;
